module.exports = __webpack_public_path__ + "img/Differentiation-OPSCC_PMID37704757.51058e42.png";